<template>
<v-select box multiple clearable v-model="selectedContacts" :items="allContacts" :label="label" :rules="rules" :no-data-text="$t('contact.no_contact_available')">
  <template slot="item" slot-scope="data">
    <v-list-tile-avatar>
      <v-icon :color="data.tile.props.value?'primary':'black'">person</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>{{data.item.text}}</v-list-tile-title>
      <v-list-tile-sub-title class="caption">{{data.item.email}}</v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action style="min-width:12px">
      <v-checkbox color="primary" v-model="data.tile.props.value"></v-checkbox>
    </v-list-tile-action>
  </template>
</v-select>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'ContactSelector',
  mixins: [UserAuth],
  props: {
    value: {
      type: Array
    },
    label: {
      type: String
    },
    rules: {
      type: Array
    }
  },
  computed: {
    selectedContacts: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    allContacts() {
      let list = [];
      Object.keys(this.userContact || {}).forEach(key => {
        let c = this.userContact[key];
        list.push({
          text: c.name,
          email: c.email,
          value: key
        })
      });
      return list.sort((a, b) => (a.text || '').localeCompare(b.text));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactSelector.vue